module.exports = __webpack_public_path__ + "static/media/blanka-stacked-white.582eda40.png";